import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCardPhoneCall = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "credit-card-phone-call" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,7.5V2.25a1.5,1.5,0,0,0-1.5-1.5H2.25a1.5,1.5,0,0,0-1.5,1.5v12a1.5,1.5,0,0,0,1.5,1.5h7.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 5.25,
			x2: 20.25,
			y2: 5.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 9,
			x2: 9.75,
			y2: 9
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 12,
			x2: 6.75,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.8,18.579,18.579,19.8a21.5,21.5,0,0,1-3.663,2.938l-.007,0a3.227,3.227,0,0,1-4.014-.44l-.452-.452a1.076,1.076,0,0,1,0-1.521l1.9-1.9a1.076,1.076,0,0,1,1.521,0h0a1.077,1.077,0,0,0,1.522,0l3.042-3.042a1.075,1.075,0,0,0,0-1.522h0a1.076,1.076,0,0,1,0-1.521l1.9-1.9a1.076,1.076,0,0,1,1.521,0l.452.452a3.226,3.226,0,0,1,.44,4.014l0,.008A21.537,21.537,0,0,1,19.8,18.579Z"
		})
	]
});
export default SvgCreditCardPhoneCall;
